// extracted by mini-css-extract-plugin
export default {"Popup":"Popup_Popup__53Ct7","Success":"Popup_Success__R9cGk","Error":"Popup_Error__PjVZX","Warning":"Popup_Warning__X8hP2","Notification":"Popup_Notification__EhS96"};